import React from "react";

const FormsContext = React.createContext();

export default FormsContext;